export default {
  path: '/style1',
  name: 'Index',
  component: () => import(`@/views/style1/Index.vue`),
  children: [
    {
      path: 'home',
      name: 'Home',
      component: () => import(`@/views/style1/Home.vue`),
    },
    {
      path: 'info',
      name: 'Info',
      component: () => import(`@/views/style1/Info.vue`),
    },
    {
      path: 'project',
      name: 'Project',
      component: () => import(`@/views/style1/Project.vue`),
    },
    {
      path: 'news',
      name: 'News',
      component: () => import(`@/views/style1/News.vue`),
    },
    {
      path: 'contact',
      name: 'Contact',
      component: () => import(`@/views/style1/Contact.vue`),
    },
    {
      path: 'detail',
      name: 'NewsDetail',
      component: () => import(`@/views/style1/NewsDetail.vue`),
    },
    {
      path: 'expert',
      name: 'EXPERT',
      component: () => import(`@/views/style1/Expert.vue`),
    },
  ]
}
